import { PartialTranslation } from '../translations';

export const mr: PartialTranslation = {
  newChat: 'नवीन चैट',
  search: 'शोधा',
  user: 'वापरकर्ता',
  settings: 'सेटिंग्ज',
  language: 'भाषा',
  getHelp: 'मदत मिळवा',
  viewAllPlans: 'सर्व योजना पहा',
  learnMore: 'अधिक जाणून घ्या',
  logOut: 'लॉग आउट',
  chooseLanguage: 'भाषा निवडा',
  chooseYourPreferredLanguage: 'तुमची पसंतीची भाषा निवडा',
  searchLanguages: 'भाषा शोधा...',
  autoDetect: 'स्वयंचलित शोध',
  noLanguagesFound: 'कोणत्याही भाषा सापडल्या नाहीत',
  askAnything: 'काहीही विचारा',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'वैयक्तिक',
  freePlan: 'मोफत योजना',
  current: 'सध्याची',
  close: 'बंद करा',
  archive: 'संग्रहण',
  delete: 'हटवा',
  confirmDelete: 'तुम्हाला खरोखर हे चॅट हटवायचे आहे का?',
  confirmArchive: 'तुम्हाला खरोखर हे चॅट संग्रहित करायचे आहे का?',
  deleteCannotUndo: 'ही क्रिया पूर्ववत करता येणार नाही.',
  archiveCanFind: 'संग्रहित केल्यानंतर तुम्ही ते संग्रह यादीत शोधू शकता.',
  // 资源面板
  resources: 'संसाधने',
  addResource: 'संसाधन जोडा',
  deleteResource: 'संसाधन हटवा',
  noMatchingResourcesFound: 'जुळणारी संसाधने सापडली नाहीत',
  noResourcesAvailable: 'कोणतीही संसाधने उपलब्ध नाहीत',
  hideResources: 'संसाधने लपवा',
  showResources: 'संसाधने दाखवा',
  
  // 聊天输入框
  typeMessage: 'संदेश टाइप करा...',
  thinkingOptions: 'विचार करण्याचे पर्याय',
  deleteFile: 'फाइल हटवा',
  clearSelection: 'निवड साफ करा',
  
  // 思考模式选项
  deepInsight: 'सखोल अंतर्दृष्टी · पृष्ठभाग विश्लेषण',
  deepInsightDesc: 'मुख्य मुद्द्यांची त्वरित समज',
  deepExploration: 'सखोल अन्वेषण · सर्वसमावेशक विश्लेषण',
  deepExplorationDesc: 'बहुआयामी सखोल संशोधन',
  deepDeconstruction: 'सखोल विखंडन · पद्धतशीर युक्तिवाद',
  deepDeconstructionDesc: 'स्तरानुसार प्रगतिशील विश्लेषण',
  
  // 写作模式选项
  contractReview: 'करार पुनरावलोकन · जोखीम ओळख',
  contractReviewDesc: 'क्लॉज विश्लेषण आणि अनुपालन तपासणी',
  textPolish: 'मजकूर पॉलिश · व्यावसायिक अभिव्यक्ती',
  textPolishDesc: 'भाषा ऑप्टिमायझेशन आणि संरचना समायोजन',
  legalDocuments: 'कायदेशीर दस्तऐवज · मानक मसुदा',
  legalDocumentsDesc: 'व्यावसायिक कायदेशीर दस्तऐवज लेखन',
  addAttachment: 'संलग्न जोडा',
  sendMessage: 'संदेश पाठवा',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'लॉग इन',
  register: 'नोंदणी करा',
  welcomeBack: 'LawHelper मध्ये स्वागत आहे',
  loginSubtitle: 'तुमचा AI कायदेशीर संशोधन सहाय्यक',
  continueWithGoogle: 'Google सह सुरू ठेवा',
  continueWithMicrosoft: 'Microsoft सह सुरू ठेवा',
  continueWithWeChat: 'WeChat सह सुरू ठेवा',
  orContinueWith: 'किंवा यासह सुरू ठेवा',
  emailTab: 'ईमेल',
  phoneTab: 'फोन',
  emailPlaceholder: 'तुमचा ईमेल प्रविष्ट करा',
  phonePlaceholder: 'फोन नंबर प्रविष्ट करा',
  codePlaceholder: '६ अंकी कोड प्रविष्ट करा',
  sending: 'पाठवत आहे...',
  verifying: 'पडताळत आहे...',
  verify: 'पडताळा',
  sendMagicLink: 'मॅजिक लिंक पाठवा',
  getVerificationCode: 'कोड मिळवा',
  resendCode: 'कोड पुन्हा पाठवा',
  resendIn: 'पुन्हा पाठवा',
  magicLinkSent: 'मॅजिक लिंक तुमच्या ईमेलवर पाठवली',
  magicLinkHint: 'आम्ही तुमच्या ईमेलवर एक सुरक्षित लिंक पाठवू',
  otpSent: 'पडताळणी कोड पाठवला',
  agreeToTerms: 'सुरू ठेवून, तुम्ही मान्य करता',
  privacyPolicy: 'गोपनीयता धोरण',
  termsOfService: 'सेवा अटी',
  and: 'आणि',
  privacyTitle: 'तुमची गोपनीयता महत्त्वाची आहे',
  privacyIntro: 'सर्वोत्तम अनुभव देण्यासाठी आम्ही कुकीज आणि तत्सम तंत्रज्ञान वापरतो.',
  essentialCookies: 'आवश्यक कुकीज',
  essentialDesc: 'वेबसाइट कार्य करण्यासाठी आवश्यक',
  analyticsCookies: 'विश्लेषण कुकीज',
  analyticsDesc: 'सेवा सुधारण्यास मदत करते',
  marketingCookies: 'मार्केटिंग कुकीज',
  marketingDesc: 'वैयक्तिकृत सामग्रीसाठी वापरले जाते',
  acceptAll: 'सर्व स्वीकारा',
  essentialOnly: 'फक्त आवश्यक',
  customize: 'सानुकूलित करा',
  savePreferences: 'प्राधान्ये जतन करा',
  back: 'मागे',
  readPrivacyPolicy: 'आमचे गोपनीयता धोरण वाचा',
  cookiePolicy: 'कुकी धोरण',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI पुनरावलोकन',
  aiDraft: 'AI मसुदा',
  smartAssistant: 'टेम्पलेट',

  // 知识库搜索
  enableKnowledgeSearch: 'शोध सक्षम करा',
  knowledgeSearchDesc: 'AI तुमच्या कागदपत्रांमध्ये शोधते',
  clickToDisable: 'अक्षम करा',
  clickToEnable: 'सक्षम करा',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'जलद उत्तर',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'रद्द करा',
  library: 'ग्रंथालय',
  filterAll: 'सर्व',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'विचार करत आहे...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'सामान्य',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'बद्दल',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'स्मार्ट दस्तऐवज सहाय्यक',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'त्रुटी',
  unknownError: 'Unknown error',
  file: 'फाइल',
  loading: 'लोड होत आहे...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI विश्लेषण',
};
